/* Foyer Gourmand – scripts du thème */
(function () {
  'use strict';
  var TD = window.themeData || { routes: {}, strings: {} };
  var R = TD.routes, S = TD.strings;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function lang() { return document.documentElement.lang || 'fr'; }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(lang(), { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  }
  var toastTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on'); clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  /* ---------- bandeau d'annonces ---------- */
  (function () {
    var box = $('#us'); if (!box) return;
    var items = $$('span', box);
    if (items.length < 2 || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) { box.classList.add('all'); return; }
    var i = 0, timer;
    box.classList.add('js'); items[0].classList.add('on');
    function next() { items[i].classList.remove('on'); i = (i + 1) % items.length; items[i].classList.add('on'); }
    function start() { timer = setInterval(next, 3500); }
    start();
    box.parentNode.addEventListener('mouseenter', function () { clearInterval(timer); });
    box.parentNode.addEventListener('mouseleave', start);
  })();

  /* ---------- menu mobile ---------- */
  (function () {
    var b = $('#bur'), n = $('#mnav'); if (!b || !n) return;
    function set(o) { n.classList.toggle('open', o); b.setAttribute('aria-expanded', o); }
    b.addEventListener('click', function () { set(!n.classList.contains('open')); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    if (window.matchMedia) matchMedia('(min-width: 901px)').addEventListener('change', function (e) { if (e.matches) set(false); });
  })();

  /* ---------- sélecteur de langue ---------- */
  (function () {
    var lb = $('#lb'), lm = $('#lm'), form = $('#LangForm'), code = $('#LangCode'); if (!lb || !lm || !form) return;
    function open(o) { lm.hidden = !o; lb.setAttribute('aria-expanded', o); }
    lb.addEventListener('click', function (e) { e.stopPropagation(); open(lm.hidden); });
    $$('button[data-lang]', lm).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); code.value = b.getAttribute('data-lang'); form.submit(); });
    });
    document.addEventListener('click', function () { open(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
  })();

  /* ---------- panier ---------- */
  function drawer() { return $('#cart-drawer'); }
  function openDrawer() { var d = drawer(); if (!d) return; d.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeDrawer() { var d = drawer(); if (!d) return; d.hidden = true; document.body.style.overflow = ''; }
  function refreshCart(open) {
    return fetch(R.root + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
      var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html'), nd = doc.querySelector('#cart-drawer'), cur = drawer();
      if (nd && cur) { cur.innerHTML = nd.innerHTML; }
      return fetch(R.cart + '.js', { headers: { Accept: 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (c) {
      var n = $('#cart-count'); if (n) n.textContent = c.item_count;
      if (open) openDrawer();
    });
  }
  function addToCart(id, qty, name) {
    return fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(id), quantity: qty || 1 }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || S.error); return j; }); })
      .then(function () { return refreshCart(true); })
      .then(function () { if (name) toast(name + ' ' + S.added); })
      .catch(function (e) { toast(e.message || S.error); });
  }
  function changeLine(key, qty) {
    return fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function () { return refreshCart(false); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    var add = t.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add.getAttribute('data-add'), 1, add.getAttribute('data-name')); return; }
    var ch = t.closest('[data-change]');
    if (ch) { e.preventDefault(); changeLine(ch.getAttribute('data-change'), parseInt(ch.getAttribute('data-qty'), 10)); return; }
    var op = t.closest('[data-cart-open]');
    if (op && !document.body.classList.contains('template-cart') && drawer()) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-drawer-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- galeries (miniatures glissantes) ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g), thumbs = $$('.th', g), track = $('[data-gallery-track]', g), count = $('[data-gallery-count]', g), cur = 0;
    if (!main || thumbs.length < 2) return;
    function go(n) {
      cur = (n + thumbs.length) % thumbs.length;
      main.src = thumbs[cur].getAttribute('data-src'); main.alt = thumbs[cur].getAttribute('data-alt') || '';
      if (count) count.textContent = (cur + 1) + ' / ' + thumbs.length;
      var o = Math.max(0, Math.min(thumbs.length - 5, cur - 2));
      if (track) track.style.setProperty('--o', o);
      thumbs.forEach(function (b, k) { b.setAttribute('aria-current', k === cur); b.tabIndex = (k >= o && k < o + 5) ? 0 : -1; });
    }
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    var p = $('[data-gallery-prev]', g), n = $('[data-gallery-next]', g);
    if (p) p.addEventListener('click', function () { go(cur - 1); });
    if (n) n.addEventListener('click', function () { go(cur + 1); });
    g.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(cur - 1); if (e.key === 'ArrowRight') go(cur + 1); });
    go(0);
  });

  /* ---------- défilé de produits ---------- */
  (function () {
    var m = $('[data-marquee]'), t = m && $('.mt', m); if (!m || !t) return;
    var n = t.children.length; if (n < 2) return;
    t.innerHTML += t.innerHTML;
    $$('.cd', t).slice(n).forEach(function (c) { c.setAttribute('aria-hidden', 'true'); $$('a,button', c).forEach(function (x) { x.tabIndex = -1; }); });
    var per = 0, pos = 0, paused = false, last = 0, reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function measure() { per = t.children[n] ? t.children[n].offsetLeft - t.children[0].offsetLeft : 0; }
    m.addEventListener('mouseenter', function () { paused = true; });
    m.addEventListener('mouseleave', function () { paused = false; });
    m.addEventListener('focusin', function () { paused = true; });
    m.addEventListener('focusout', function () { paused = false; });
    m.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    m.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 2500); }, { passive: true });
    m.addEventListener('scroll', function () { if (Math.abs(m.scrollLeft - pos) > 2) pos = m.scrollLeft; if (per && m.scrollLeft >= per) { m.scrollLeft -= per; pos = m.scrollLeft; } }, { passive: true });
    function step(ts) {
      if (!last) last = ts; var dt = Math.min(ts - last, 80); last = ts; if (!per) measure();
      if (!paused && !reduce && per) { pos += dt * 0.04; if (pos >= per) pos -= per; m.scrollLeft = pos; }
      requestAnimationFrame(step);
    }
    window.addEventListener('resize', measure); requestAnimationFrame(step);
  })();

  /* ---------- « Trouvez votre appareil » ---------- */
  $$('[data-finder]').forEach(function (root) {
    var dataEl = $('[data-finder-data]', root.parentNode); if (!dataEl) return;
    var P = []; try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var B = [['Moins de 150 €', 0, 150], ['150 à 300 €', 150, 300], ['300 à 1 000 €', 300, 1000], ['Plus de 1 000 €', 1000, 1e9]];
    var N = [['Petit foyer (1 à 3 personnes)', function (p) { return p.fry && p.cap > 0 && p.cap <= 4.7; }], ['Grande famille', function (p) { return p.fry && p.cap >= 6; }],
      ['Deux plats en même temps', function (p) { return p.dbl; }], ['Un bon café', function (p) { return p.cafe; }], ['Un robot cuiseur', function (p) { return p.rob; }]];
    var sb = parseInt(root.getAttribute('data-default-budget'), 10); if (isNaN(sb)) sb = -1; var sn = -1;
    var bBox = $('[data-finder-budget]', root), nBox = $('[data-finder-need]', root), cnt = $('[data-finder-count]', root), res = $('[data-finder-results]', root), more = $('[data-finder-more]', root);
    function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
    function chip(box, txt, i, get, set) { var b = el('button', 'chip', txt); b.type = 'button'; b.setAttribute('aria-pressed', 'false'); b.addEventListener('click', function () { set(get() === i ? -1 : i); render(); }); box.appendChild(b); }
    B.forEach(function (x, i) { chip(bBox, x[0], i, function () { return sb; }, function (v) { sb = v; }); });
    N.forEach(function (x, i) { chip(nBox, x[0], i, function () { return sn; }, function (v) { sn = v; }); });
    function render() {
      $$('button', bBox).forEach(function (c, i) { c.setAttribute('aria-pressed', i === sb); });
      $$('button', nBox).forEach(function (c, i) { c.setAttribute('aria-pressed', i === sn); });
      res.innerHTML = '';
      if (sb < 0 && sn < 0) { cnt.textContent = S.pick; more.hidden = true; return; }
      var r = P.filter(function (p) { return (sb < 0 || (p.p >= B[sb][1] && p.p < B[sb][2])) && (sn < 0 || N[sn][1](p)); }).sort(function (a, b) { return a.p - b.p; });
      cnt.textContent = r.length ? r.length + ' ' + (r.length > 1 ? S.manyMatch : S.oneMatch) + (r.length > 6 ? ' ' + S.cheapest : '') : S.none;
      more.hidden = !r.length;
      r.slice(0, 6).forEach(function (p) {
        var a = el('a', 'rc'); a.href = p.u; var th = el('div', 'rt');
        if (p.i) { var im = el('img'); im.src = p.i; im.alt = ''; im.loading = 'lazy'; th.appendChild(im); } else th.appendChild(el('div', 'ph', p.b));
        var x = el('div'); x.appendChild(el('small', '', p.b)); x.appendChild(el('b', '', p.t)); x.appendChild(el('i', 'pv', money(p.p * 100)));
        a.appendChild(th); a.appendChild(x); res.appendChild(a);
      });
    }
    render();
  });

  /* ---------- vidéos ---------- */
  (function () {
    var m = $('#vm'); if (!m) return;
    var fr = $('#vfr'), tt = $('#vmt'), nt = $('#vnote'), last = null;
    function embed(u) {
      u = (u || '').replace(/["'<>\s]/g, '');
      var y = u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
      if (y) return '<iframe src="https://www.youtube-nocookie.com/embed/' + y[1] + '?autoplay=1" title="Vidéo" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>';
      var v = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (v) return '<iframe src="https://player.vimeo.com/video/' + v[1] + '?autoplay=1" title="Vidéo" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      if (/^https:\/\/.+\.(mp4|webm)(\?.*)?$/i.test(u)) return '<video src="' + u + '" controls autoplay playsinline></video>';
      return '';
    }
    function open(b) {
      last = b; tt.textContent = b.getAttribute('data-title') || ''; var h = embed(b.getAttribute('data-url')); fr.innerHTML = '';
      if (h) { fr.innerHTML = h; nt.textContent = ''; }
      else {
        var im = $('img', b), p = document.createElement('div'); p.className = 'vph';
        if (im && im.src) { var i2 = document.createElement('img'); i2.src = im.src; i2.alt = ''; p.appendChild(i2); }
        var s = document.createElement('span'); s.textContent = S.soon; p.appendChild(s); fr.appendChild(p); nt.textContent = S.soonNote;
      }
      m.hidden = false; document.body.style.overflow = 'hidden';
    }
    function close() { m.hidden = true; fr.innerHTML = ''; document.body.style.overflow = ''; if (last && last.focus) last.focus(); }
    document.addEventListener('click', function (e) {
      var t = e.target; if (!t.closest) return;
      var b = t.closest('[data-vid]'); if (b) { e.preventDefault(); open(b); return; }
      if (t.closest('[data-vclose]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
  })();

  /* ---------- page catégorie : filtres et tri ---------- */
  (function () {
    var form = $('[data-filter-form]'); if (!form) return;
    var fl = $('#fl'), timer;
    function submit() { form.submit(); }
    $$('input', form).forEach(function (i) { i.addEventListener('change', function () { clearTimeout(timer); timer = setTimeout(submit, 350); }); });
    var sort = $('[data-sort]'); if (sort) sort.addEventListener('change', submit);
    function op(o) { if (fl) fl.classList.toggle('open', o); document.body.style.overflow = o ? 'hidden' : ''; }
    $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', function () { op(true); }); });
    $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', function () { op(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') op(false); });
  })();

  /* ---------- fiche produit ---------- */
  (function () {
    var sec = $('[data-product-section]'); if (!sec) return;
    var vEl = $('[data-variants]'), variants = []; try { variants = JSON.parse(vEl.textContent); } catch (e) {}
    var form = $('#ProductForm'), idInput = $('[data-variant-id]', form), sel = $('[data-variant-select]', form), qty = $('[data-qty]', form);
    var priceEl = $('[data-price]', sec), cmpEl = $('[data-compare]', sec), badge = $('[data-badge]', sec), save = $('[data-save]', sec), stock = $('[data-stock]', sec), skuEl = $('[data-sku]', sec);
    var addBtn = $('[data-add-form]', form), sAdd = $('[data-sticky-add]'), sPrice = $('[data-sticky-price]'), low = TD.lowStock || 4;
    var tax = save ? save.textContent.split('·').pop().trim() : '';
    function find(id) { return variants.filter(function (v) { return String(v.id) === String(id); })[0]; }
    function paint(v) {
      if (!v) return;
      priceEl.textContent = v.priceFmt; if (sPrice) sPrice.textContent = v.priceFmt;
      var on = v.compare && v.compare > v.price;
      if (cmpEl) { cmpEl.hidden = !on; if (on) cmpEl.textContent = v.compareFmt; }
      if (badge) { badge.hidden = !on; if (on) badge.textContent = '−' + Math.round((1 - v.price / v.compare) * 100) + ' %'; }
      if (save) save.textContent = (on ? money(v.compare - v.price) + ' · ' : '') + tax;
      if (stock) {
        if (!v.available) { stock.hidden = false; stock.className = 'stk out'; stock.textContent = (addBtn && addBtn.getAttribute('data-sold')) || 'Rupture de stock'; }
        else if (v.tracked) { stock.hidden = false; stock.className = 'stk ' + (v.qty <= low ? 'low' : 'in'); stock.textContent = v.qty <= low ? 'Plus que ' + v.qty + ' en stock' : 'En stock'; }
        else stock.hidden = true;
      }
      [addBtn, sAdd].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (skuEl && v.sku) skuEl.textContent = skuEl.textContent.split(':')[0] + ': ' + v.sku;
      if (idInput) idInput.value = v.id;
      if (window.history && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
    }
    var cur = idInput ? find(idInput.value) : null; paint(cur);
    if (sel) sel.addEventListener('change', function () { paint(find(sel.value)); });
    var minus = $('[data-qty-minus]', form), plus = $('[data-qty-plus]', form);
    function setQty(n) { qty.value = Math.max(1, Math.min(10, n)); }
    if (minus) minus.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + 1); });
    form.addEventListener('submit', function (e) {
      e.preventDefault(); var v = find(idInput.value); if (v && !v.available) return;
      addToCart(idInput.value, parseInt(qty.value, 10) || 1, $('h1', sec).textContent);
    });
    if (sAdd) sAdd.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : addBtn.click(); });
    var bar = $('[data-sticky-bar]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { bar.classList.toggle('show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(addBtn);
    }
  })();

  /* ---------- recommandations produits ---------- */
  $$('[data-recommendations]').forEach(function (box) {
    var url = box.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html'), nw = doc.querySelector('[data-recommendations]');
      if (nw && nw.innerHTML.trim().length) box.innerHTML = nw.innerHTML;
    }).catch(function () {});
  });

  /* ---------- article : sommaire, encadré, progression ---------- */
  (function () {
    var body = $('[data-article-body]'); if (!body) return;
    var toc = $('[data-toc]'), keepWord = ((TD.strings && TD.strings.keep) || 'À retenir').toLowerCase();
    $$('h2', body).forEach(function (h, k) {
      var txt = h.textContent.trim();
      if (txt.toLowerCase() === 'à retenir' || txt.toLowerCase() === keepWord || txt.toLowerCase() === 'key takeaways') {
        var box = document.createElement('aside'); box.className = 'keep'; h.parentNode.insertBefore(box, h); box.appendChild(h);
        var nx = box.nextElementSibling; if (nx && (nx.tagName === 'UL' || nx.tagName === 'OL')) box.appendChild(nx);
        return;
      }
      h.id = 's-' + k;
      if (toc) { var li = document.createElement('li'), a = document.createElement('a'); a.href = '#s-' + k; a.textContent = txt; li.appendChild(a); toc.appendChild(li); }
    });
    if (toc && !toc.children.length) { var side = toc.closest('.side'); if (side) side.hidden = true; }
    var bar = $('[data-progress]');
    if (bar) window.addEventListener('scroll', function () { var h = document.documentElement, s = h.scrollTop / ((h.scrollHeight - h.clientHeight) || 1); bar.style.width = (s * 100) + '%'; }, { passive: true });
  })();

  /* ---------- connexion : mot de passe oublié ---------- */
  $$('[data-recover]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); var r = $('#recover'); if (r) r.hidden = !r.hidden; }); });
})();
